[
  {
    "date": "2025-12-03 13:00:00",
    "open": 100000,
    "low": 99860.79,
    "high": 100136.04,
    "close": 99979.15,
    "volume": 60709626
  },
  {
    "date": "2025-12-03 14:00:00",
    "open": 99979.15,
    "low": 99669.7,
    "high": 102405.44,
    "close": 100806.04,
    "volume": 64874217
  },
  {
    "date": "2025-12-03 15:00:00",
    "open": 100806.04,
    "low": 99596.54,
    "high": 102049.17,
    "close": 99895.54,
    "volume": 62595475
  },
  {
    "date": "2025-12-03 16:00:00",
    "open": 99895.54,
    "low": 98198.63,
    "high": 106446.69,
    "close": 102746.47,
    "volume": 62564122
  },
  {
    "date": "2025-12-03 17:00:00",
    "open": 102746.47,
    "low": 102616.67,
    "high": 103239.39,
    "close": 102932.42,
    "volume": 48178728
  },
  {
    "date": "2025-12-03 18:00:00",
    "open": 102932.42,
    "low": 102713.71,
    "high": 103143.41,
    "close": 103037.93,
    "volume": 54415151
  },
  {
    "date": "2025-12-03 19:00:00",
    "open": 103037.93,
    "low": 100979.07,
    "high": 107077.9,
    "close": 104787.11,
    "volume": 178144422
  },
  {
    "date": "2025-12-03 20:00:00",
    "open": 104787.11,
    "low": 102888.39,
    "high": 108839.29,
    "close": 106487.65,
    "volume": 43656599
  },
  {
    "date": "2025-12-03 21:00:00",
    "open": 106487.65,
    "low": 104670.3,
    "high": 107789.55,
    "close": 105381.02,
    "volume": 42787268
  },
  {
    "date": "2025-12-03 22:00:00",
    "open": 105381.02,
    "low": 103499.97,
    "high": 107159.65,
    "close": 104054.04,
    "volume": 63209171
  },
  {
    "date": "2025-12-03 23:00:00",
    "open": 104054.04,
    "low": 103770.5,
    "high": 104378.5,
    "close": 104198.01,
    "volume": 61610406
  },
  {
    "date": "2025-12-04 00:00:00",
    "open": 104198.01,
    "low": 104038.6,
    "high": 104952.35,
    "close": 104502.68,
    "volume": 60912115
  },
  {
    "date": "2025-12-04 01:00:00",
    "open": 104502.68,
    "low": 101740.94,
    "high": 105495.01,
    "close": 103410.99,
    "volume": 41213472
  },
  {
    "date": "2025-12-04 02:00:00",
    "open": 103410.99,
    "low": 101261.94,
    "high": 105618.79,
    "close": 104809.28,
    "volume": 57617557
  },
  {
    "date": "2025-12-04 03:00:00",
    "open": 104809.28,
    "low": 104628.21,
    "high": 104993.36,
    "close": 104850.61,
    "volume": 53721788
  },
  {
    "date": "2025-12-04 04:00:00",
    "open": 104850.61,
    "low": 103842.12,
    "high": 106045.71,
    "close": 105363.04,
    "volume": 46443352
  },
  {
    "date": "2025-12-04 05:00:00",
    "open": 105363.04,
    "low": 105181.91,
    "high": 105547.99,
    "close": 105403.69,
    "volume": 43871845
  },
  {
    "date": "2025-12-04 06:00:00",
    "open": 105403.69,
    "low": 105228.56,
    "high": 109036.36,
    "close": 106770.98,
    "volume": 51640041
  },
  {
    "date": "2025-12-04 07:00:00",
    "open": 106770.98,
    "low": 105788.87,
    "high": 110698.4,
    "close": 108093.97,
    "volume": 62929258
  },
  {
    "date": "2025-12-04 08:00:00",
    "open": 108093.97,
    "low": 104257.59,
    "high": 108484.1,
    "close": 106071.43,
    "volume": 43658650
  },
  {
    "date": "2025-12-04 09:00:00",
    "open": 106071.43,
    "low": 104362.55,
    "high": 108274.26,
    "close": 104733.12,
    "volume": 54737425
  },
  {
    "date": "2025-12-04 10:00:00",
    "open": 104733.12,
    "low": 103597.39,
    "high": 110083.51,
    "close": 106543.98,
    "volume": 61746825
  },
  {
    "date": "2025-12-04 11:00:00",
    "open": 106543.98,
    "low": 105049.02,
    "high": 107735.61,
    "close": 107280.08,
    "volume": 43119108
  },
  {
    "date": "2025-12-04 12:00:00",
    "open": 107280.08,
    "low": 106882.63,
    "high": 108387.98,
    "close": 107659.36,
    "volume": 48621976
  },
  {
    "date": "2025-12-04 13:00:00",
    "open": 107659.36,
    "low": 106607.5,
    "high": 111523.76,
    "close": 109287.67,
    "volume": 49868775
  },
  {
    "date": "2025-12-04 14:00:00",
    "open": 109287.67,
    "low": 109165.14,
    "high": 109418.6,
    "close": 109299.49,
    "volume": 43380665
  },
  {
    "date": "2025-12-04 15:00:00",
    "open": 109299.49,
    "low": 108569.99,
    "high": 111184.55,
    "close": 110493.37,
    "volume": 59080304
  },
  {
    "date": "2025-12-04 16:00:00",
    "open": 110493.37,
    "low": 105994.76,
    "high": 113084.35,
    "close": 108758.85,
    "volume": 62764747
  },
  {
    "date": "2025-12-04 17:00:00",
    "open": 108758.85,
    "low": 108498.69,
    "high": 109146.06,
    "close": 108979.66,
    "volume": 59799074
  },
  {
    "date": "2025-12-04 18:00:00",
    "open": 108979.66,
    "low": 108596,
    "high": 109442.7,
    "close": 109229.38,
    "volume": 48041474
  },
  {
    "date": "2025-12-04 19:00:00",
    "open": 109229.38,
    "low": 107249.54,
    "high": 110905.9,
    "close": 108310.16,
    "volume": 44173903
  },
  {
    "date": "2025-12-04 20:00:00",
    "open": 108310.16,
    "low": 107898.33,
    "high": 108882.06,
    "close": 108041.47,
    "volume": 52165185
  },
  {
    "date": "2025-12-04 21:00:00",
    "open": 108041.47,
    "low": 106660.55,
    "high": 108961.49,
    "close": 107554.24,
    "volume": 40039837
  },
  {
    "date": "2025-12-04 22:00:00",
    "open": 107554.24,
    "low": 106466.68,
    "high": 109931.01,
    "close": 108944.79,
    "volume": 46543727
  },
  {
    "date": "2025-12-04 23:00:00",
    "open": 108944.79,
    "low": 107482.09,
    "high": 111562.46,
    "close": 110859.11,
    "volume": 57022606
  },
  {
    "date": "2025-12-05 00:00:00",
    "open": 110859.11,
    "low": 110189.1,
    "high": 111154.16,
    "close": 110664.55,
    "volume": 56781909
  },
  {
    "date": "2025-12-05 01:00:00",
    "open": 110664.55,
    "low": 94626.2,
    "high": 126520.97,
    "close": 98026.07,
    "volume": 171845518
  },
  {
    "date": "2025-12-05 02:00:00",
    "open": 98026.07,
    "low": 81725.99,
    "high": 111527.37,
    "close": 90048.25,
    "volume": 133254054
  },
  {
    "date": "2025-12-05 03:00:00",
    "open": 90048.25,
    "low": 87493.43,
    "high": 90297.08,
    "close": 88577.94,
    "volume": 48950588
  },
  {
    "date": "2025-12-05 04:00:00",
    "open": 88577.94,
    "low": 87962.73,
    "high": 89925.51,
    "close": 89528.73,
    "volume": 59622341
  },
  {
    "date": "2025-12-05 05:00:00",
    "open": 89528.73,
    "low": 88631.68,
    "high": 90507.4,
    "close": 89956.56,
    "volume": 41406358
  },
  {
    "date": "2025-12-05 06:00:00",
    "open": 89956.56,
    "low": 89772.01,
    "high": 90172.75,
    "close": 90026.99,
    "volume": 44835957
  },
  {
    "date": "2025-12-05 07:00:00",
    "open": 90026.99,
    "low": 88027.4,
    "high": 93050.98,
    "close": 91926.02,
    "volume": 54101688
  },
  {
    "date": "2025-12-05 08:00:00",
    "open": 91926.02,
    "low": 81045.97,
    "high": 117947.92,
    "close": 110529.22,
    "volume": 184375157
  },
  {
    "date": "2025-12-05 09:00:00",
    "open": 110529.22,
    "low": 106291.95,
    "high": 115062.04,
    "close": 108306.06,
    "volume": 162796891
  },
  {
    "date": "2025-12-05 10:00:00",
    "open": 108306.06,
    "low": 106662.2,
    "high": 111344.92,
    "close": 109663.57,
    "volume": 40435010
  },
  {
    "date": "2025-12-05 11:00:00",
    "open": 109663.57,
    "low": 105707.67,
    "high": 113912.09,
    "close": 111630.31,
    "volume": 47563624
  },
  {
    "date": "2025-12-05 12:00:00",
    "open": 111630.31,
    "low": 110531.81,
    "high": 111998.51,
    "close": 111240.93,
    "volume": 52800876
  },
  {
    "date": "2025-12-05 13:00:00",
    "open": 111240.93,
    "low": 101230.04,
    "high": 121809.12,
    "close": 101511.21,
    "volume": 148918602
  },
  {
    "date": "2025-12-05 14:00:00",
    "open": 101511.21,
    "low": 100645.49,
    "high": 101819.33,
    "close": 101231.1,
    "volume": 49242475
  },
  {
    "date": "2025-12-05 15:00:00",
    "open": 101231.1,
    "low": 100134.28,
    "high": 102198.34,
    "close": 100730.55,
    "volume": 57954877
  },
  {
    "date": "2025-12-05 16:00:00",
    "open": 100730.55,
    "low": 100315.89,
    "high": 102740.02,
    "close": 101497.62,
    "volume": 53527885
  },
  {
    "date": "2025-12-05 17:00:00",
    "open": 101497.62,
    "low": 98401.82,
    "high": 104262.21,
    "close": 99966.51,
    "volume": 57240364
  },
  {
    "date": "2025-12-05 18:00:00",
    "open": 99966.51,
    "low": 99362.67,
    "high": 102270.34,
    "close": 101476.48,
    "volume": 45439306
  },
  {
    "date": "2025-12-05 19:00:00",
    "open": 101476.48,
    "low": 100547.53,
    "high": 102323.15,
    "close": 101994.98,
    "volume": 40802719
  },
  {
    "date": "2025-12-05 20:00:00",
    "open": 101994.98,
    "low": 100236.71,
    "high": 105227.22,
    "close": 103069.51,
    "volume": 64508175
  },
  {
    "date": "2025-12-05 21:00:00",
    "open": 103069.51,
    "low": 102769.16,
    "high": 103923.52,
    "close": 103434.62,
    "volume": 51472448
  },
  {
    "date": "2025-12-05 22:00:00",
    "open": 103434.62,
    "low": 101222.74,
    "high": 104078.06,
    "close": 101967.23,
    "volume": 42891628
  },
  {
    "date": "2025-12-05 23:00:00",
    "open": 101967.23,
    "low": 97589.23,
    "high": 116265.56,
    "close": 107256.97,
    "volume": 163757853
  },
  {
    "date": "2025-12-06 00:00:00",
    "open": 107256.97,
    "low": 105445.01,
    "high": 108863.41,
    "close": 106076.73,
    "volume": 40108482
  },
  {
    "date": "2025-12-06 01:00:00",
    "open": 106076.73,
    "low": 105323.68,
    "high": 109000.15,
    "close": 107542.96,
    "volume": 112900091
  },
  {
    "date": "2025-12-06 02:00:00",
    "open": 107542.96,
    "low": 106034.98,
    "high": 108146.16,
    "close": 106623.42,
    "volume": 45632956
  },
  {
    "date": "2025-12-06 03:00:00",
    "open": 106623.42,
    "low": 106182.95,
    "high": 106848.77,
    "close": 106472.38,
    "volume": 48217760
  },
  {
    "date": "2025-12-06 04:00:00",
    "open": 106472.38,
    "low": 106239.13,
    "high": 109327.18,
    "close": 107904.24,
    "volume": 47364113
  },
  {
    "date": "2025-12-06 05:00:00",
    "open": 107904.24,
    "low": 104786.3,
    "high": 110355.55,
    "close": 106282.01,
    "volume": 41777466
  },
  {
    "date": "2025-12-06 06:00:00",
    "open": 106282.01,
    "low": 104014.22,
    "high": 115492,
    "close": 110350.16,
    "volume": 121160793
  },
  {
    "date": "2025-12-06 07:00:00",
    "open": 110350.16,
    "low": 109252.37,
    "high": 110980.29,
    "close": 109646.66,
    "volume": 55936919
  },
  {
    "date": "2025-12-06 08:00:00",
    "open": 109646.66,
    "low": 107423.02,
    "high": 111041.59,
    "close": 110712.51,
    "volume": 50799186
  },
  {
    "date": "2025-12-06 09:00:00",
    "open": 110712.51,
    "low": 105832.2,
    "high": 114862.27,
    "close": 108686.81,
    "volume": 49902290
  },
  {
    "date": "2025-12-06 10:00:00",
    "open": 108686.81,
    "low": 104177.33,
    "high": 108801.78,
    "close": 107084.68,
    "volume": 46930460
  },
  {
    "date": "2025-12-06 11:00:00",
    "open": 107084.68,
    "low": 105639.6,
    "high": 110226.39,
    "close": 108443.29,
    "volume": 57964975
  },
  {
    "date": "2025-12-06 12:00:00",
    "open": 108443.29,
    "low": 107240.16,
    "high": 115511.38,
    "close": 111251.63,
    "volume": 123916157
  },
  {
    "date": "2025-12-06 13:00:00",
    "open": 111251.63,
    "low": 110872.13,
    "high": 112035.92,
    "close": 111902.48,
    "volume": 45492097
  },
  {
    "date": "2025-12-06 14:00:00",
    "open": 111902.48,
    "low": 106593.58,
    "high": 112146.32,
    "close": 110045.93,
    "volume": 63628661
  },
  {
    "date": "2025-12-06 15:00:00",
    "open": 110045.93,
    "low": 105543.7,
    "high": 112612.75,
    "close": 108495.29,
    "volume": 46487499
  },
  {
    "date": "2025-12-06 16:00:00",
    "open": 108495.29,
    "low": 104733.66,
    "high": 111047.35,
    "close": 106707.02,
    "volume": 55760245
  },
  {
    "date": "2025-12-06 17:00:00",
    "open": 106707.02,
    "low": 106358.87,
    "high": 107059.57,
    "close": 106846.28,
    "volume": 58734407
  },
  {
    "date": "2025-12-06 18:00:00",
    "open": 106846.28,
    "low": 106553.07,
    "high": 108472.33,
    "close": 107908.95,
    "volume": 47540698
  },
  {
    "date": "2025-12-06 19:00:00",
    "open": 107908.95,
    "low": 103143.19,
    "high": 111282.09,
    "close": 105720.15,
    "volume": 60155793
  },
  {
    "date": "2025-12-06 20:00:00",
    "open": 105720.15,
    "low": 104478.36,
    "high": 105945.82,
    "close": 105314.28,
    "volume": 53751415
  },
  {
    "date": "2025-12-06 21:00:00",
    "open": 105314.28,
    "low": 101089.93,
    "high": 109014.57,
    "close": 103170.26,
    "volume": 42330749
  },
  {
    "date": "2025-12-06 22:00:00",
    "open": 103170.26,
    "low": 100982.7,
    "high": 105037.47,
    "close": 102160.03,
    "volume": 55134733
  },
  {
    "date": "2025-12-06 23:00:00",
    "open": 102160.03,
    "low": 100506.16,
    "high": 103594.67,
    "close": 103178.1,
    "volume": 42575663
  },
  {
    "date": "2025-12-07 00:00:00",
    "open": 103178.1,
    "low": 100119.7,
    "high": 104512.3,
    "close": 101975,
    "volume": 61596950
  },
  {
    "date": "2025-12-07 01:00:00",
    "open": 101975,
    "low": 100920.71,
    "high": 103991.33,
    "close": 102830.06,
    "volume": 52967648
  },
  {
    "date": "2025-12-07 02:00:00",
    "open": 102830.06,
    "low": 101189.05,
    "high": 103627.1,
    "close": 102264.15,
    "volume": 60837765
  },
  {
    "date": "2025-12-07 03:00:00",
    "open": 102264.15,
    "low": 101964.38,
    "high": 104681.25,
    "close": 103610.64,
    "volume": 44684363
  },
  {
    "date": "2025-12-07 04:00:00",
    "open": 103610.64,
    "low": 103285.2,
    "high": 103924.5,
    "close": 103486.81,
    "volume": 50435783
  },
  {
    "date": "2025-12-07 05:00:00",
    "open": 103486.81,
    "low": 101701.96,
    "high": 104627.18,
    "close": 102734.97,
    "volume": 52959032
  },
  {
    "date": "2025-12-07 06:00:00",
    "open": 102734.97,
    "low": 101150.3,
    "high": 106190.18,
    "close": 104559.43,
    "volume": 41312467
  },
  {
    "date": "2025-12-07 07:00:00",
    "open": 104559.43,
    "low": 104418.86,
    "high": 108191.34,
    "close": 105997.66,
    "volume": 53161553
  },
  {
    "date": "2025-12-07 08:00:00",
    "open": 105997.66,
    "low": 105651.5,
    "high": 108696.8,
    "close": 107119.41,
    "volume": 64124546
  },
  {
    "date": "2025-12-07 09:00:00",
    "open": 107119.41,
    "low": 102746.27,
    "high": 108861.1,
    "close": 105086.54,
    "volume": 127042983
  },
  {
    "date": "2025-12-07 10:00:00",
    "open": 105086.54,
    "low": 92527.48,
    "high": 124243.4,
    "close": 112581.2,
    "volume": 118979123
  },
  {
    "date": "2025-12-07 11:00:00",
    "open": 112581.2,
    "low": 112410.19,
    "high": 113266.27,
    "close": 112881.8,
    "volume": 52371063
  },
  {
    "date": "2025-12-07 12:00:00",
    "open": 112881.8,
    "low": 112574,
    "high": 113123.36,
    "close": 112747.73,
    "volume": 60256965
  },
  {
    "date": "2025-12-07 13:00:00",
    "open": 112747.73,
    "low": 111932.72,
    "high": 113090.59,
    "close": 112217.74,
    "volume": 49542008
  },
  {
    "date": "2025-12-07 14:00:00",
    "open": 112217.74,
    "low": 111339.08,
    "high": 112524.91,
    "close": 111589.03,
    "volume": 57838450
  },
  {
    "date": "2025-12-07 15:00:00",
    "open": 111589.03,
    "low": 110266.85,
    "high": 115363.09,
    "close": 112835.61,
    "volume": 52371328
  },
  {
    "date": "2025-12-07 16:00:00",
    "open": 112835.61,
    "low": 110434.17,
    "high": 115279.34,
    "close": 114069.35,
    "volume": 54524368
  },
  {
    "date": "2025-12-07 17:00:00",
    "open": 114069.35,
    "low": 113752.03,
    "high": 117403.57,
    "close": 115382.96,
    "volume": 51083552
  },
  {
    "date": "2025-12-07 18:00:00",
    "open": 115382.96,
    "low": 114424.66,
    "high": 118012.98,
    "close": 116462.16,
    "volume": 55399910
  },
  {
    "date": "2025-12-07 19:00:00",
    "open": 116462.16,
    "low": 116159.48,
    "high": 118239.95,
    "close": 117060.98,
    "volume": 58726866
  },
  {
    "date": "2025-12-07 20:00:00",
    "open": 117060.98,
    "low": 115857.11,
    "high": 117403,
    "close": 116585.7,
    "volume": 45056327
  },
  {
    "date": "2025-12-07 21:00:00",
    "open": 116585.7,
    "low": 113748.44,
    "high": 119344.66,
    "close": 118532.4,
    "volume": 55473610
  },
  {
    "date": "2025-12-07 22:00:00",
    "open": 118532.4,
    "low": 116960.52,
    "high": 120787.46,
    "close": 119876.71,
    "volume": 55782682
  },
  {
    "date": "2025-12-07 23:00:00",
    "open": 119876.71,
    "low": 117632.76,
    "high": 122190.48,
    "close": 121140.73,
    "volume": 57838172
  },
  {
    "date": "2025-12-08 00:00:00",
    "open": 121140.73,
    "low": 117338.74,
    "high": 124390.08,
    "close": 122996.14,
    "volume": 53506908
  },
  {
    "date": "2025-12-08 01:00:00",
    "open": 122996.14,
    "low": 122180.35,
    "high": 123953.18,
    "close": 123409,
    "volume": 60257764
  },
  {
    "date": "2025-12-08 02:00:00",
    "open": 123409,
    "low": 122145.24,
    "high": 126412.99,
    "close": 124761.09,
    "volume": 53092135
  },
  {
    "date": "2025-12-08 03:00:00",
    "open": 124761.09,
    "low": 122131.74,
    "high": 128730.81,
    "close": 127065.91,
    "volume": 53221775
  },
  {
    "date": "2025-12-08 04:00:00",
    "open": 127065.91,
    "low": 116475.76,
    "high": 145071.22,
    "close": 137236.54,
    "volume": 155859368
  },
  {
    "date": "2025-12-08 05:00:00",
    "open": 137236.54,
    "low": 136814.38,
    "high": 159333.38,
    "close": 145353.58,
    "volume": 83973608
  },
  {
    "date": "2025-12-08 06:00:00",
    "open": 145353.58,
    "low": 142947.62,
    "high": 147314,
    "close": 147147.39,
    "volume": 84134540
  },
  {
    "date": "2025-12-08 07:00:00",
    "open": 147147.39,
    "low": 146094.97,
    "high": 150444.83,
    "close": 149025.13,
    "volume": 61417012
  },
  {
    "date": "2025-12-08 08:00:00",
    "open": 149025.13,
    "low": 145690.86,
    "high": 153648.22,
    "close": 151083.69,
    "volume": 48714286
  },
  {
    "date": "2025-12-08 09:00:00",
    "open": 151083.69,
    "low": 150468.63,
    "high": 151334.14,
    "close": 150880.09,
    "volume": 40742166
  },
  {
    "date": "2025-12-08 10:00:00",
    "open": 150880.09,
    "low": 145653.33,
    "high": 152097.17,
    "close": 148501.48,
    "volume": 56704014
  },
  {
    "date": "2025-12-08 11:00:00",
    "open": 148501.48,
    "low": 145937.9,
    "high": 163303.8,
    "close": 162815.55,
    "volume": 145222622
  },
  {
    "date": "2025-12-08 12:00:00",
    "open": 162815.55,
    "low": 159168.16,
    "high": 163954.45,
    "close": 159716.02,
    "volume": 135296126
  },
  {
    "date": "2025-12-08 13:00:00",
    "open": 159716.02,
    "low": 156880.88,
    "high": 165137.71,
    "close": 157043.41,
    "volume": 59141848
  },
  {
    "date": "2025-12-08 14:00:00",
    "open": 157043.41,
    "low": 135817.67,
    "high": 180829.69,
    "close": 169076.47,
    "volume": 90143415
  },
  {
    "date": "2025-12-08 15:00:00",
    "open": 169076.47,
    "low": 161483.75,
    "high": 170451.16,
    "close": 166597.84,
    "volume": 60500541
  },
  {
    "date": "2025-12-08 16:00:00",
    "open": 166597.84,
    "low": 165425.71,
    "high": 167749.6,
    "close": 167178.68,
    "volume": 52261680
  },
  {
    "date": "2025-12-08 17:00:00",
    "open": 167178.68,
    "low": 166702.03,
    "high": 173761.2,
    "close": 170044.42,
    "volume": 71747195
  },
  {
    "date": "2025-12-08 18:00:00",
    "open": 170044.42,
    "low": 122925.82,
    "high": 170990.93,
    "close": 152596.58,
    "volume": 175685210
  },
  {
    "date": "2025-12-08 19:00:00",
    "open": 152596.58,
    "low": 151693.63,
    "high": 152949.77,
    "close": 151847.84,
    "volume": 48255796
  },
  {
    "date": "2025-12-08 20:00:00",
    "open": 151847.84,
    "low": 150224.81,
    "high": 158566.61,
    "close": 154079.58,
    "volume": 51064180
  },
  {
    "date": "2025-12-08 21:00:00",
    "open": 154079.58,
    "low": 150150.11,
    "high": 155348.09,
    "close": 152633.49,
    "volume": 58496161
  },
  {
    "date": "2025-12-08 22:00:00",
    "open": 152633.49,
    "low": 149791.12,
    "high": 170248.42,
    "close": 161090.73,
    "volume": 162063820
  },
  {
    "date": "2025-12-08 23:00:00",
    "open": 161090.73,
    "low": 148738.98,
    "high": 174222.11,
    "close": 153226.4,
    "volume": 158395464
  },
  {
    "date": "2025-12-09 00:00:00",
    "open": 153226.4,
    "low": 153015.78,
    "high": 153421.91,
    "close": 153201.25,
    "volume": 59941425
  },
  {
    "date": "2025-12-09 01:00:00",
    "open": 153201.25,
    "low": 152941.55,
    "high": 153416.04,
    "close": 153150.66,
    "volume": 46799213
  },
  {
    "date": "2025-12-09 02:00:00",
    "open": 153150.66,
    "low": 150652.36,
    "high": 156704.58,
    "close": 154406.55,
    "volume": 57688881
  },
  {
    "date": "2025-12-09 03:00:00",
    "open": 154406.55,
    "low": 147197.3,
    "high": 154806.47,
    "close": 151795.1,
    "volume": 40389158
  },
  {
    "date": "2025-12-09 04:00:00",
    "open": 151795.1,
    "low": 143173.28,
    "high": 178904.33,
    "close": 169198.81,
    "volume": 139457964
  },
  {
    "date": "2025-12-09 05:00:00",
    "open": 169198.81,
    "low": 164469.52,
    "high": 171891.76,
    "close": 167433.04,
    "volume": 53692209
  },
  {
    "date": "2025-12-09 06:00:00",
    "open": 167433.04,
    "low": 163008.32,
    "high": 173126.96,
    "close": 171306.34,
    "volume": 87539985
  },
  {
    "date": "2025-12-09 07:00:00",
    "open": 171306.34,
    "low": 169939.78,
    "high": 171498.57,
    "close": 170832.68,
    "volume": 182817731
  },
  {
    "date": "2025-12-09 08:00:00",
    "open": 170832.68,
    "low": 165603.6,
    "high": 175260.57,
    "close": 168598.31,
    "volume": 46329698
  },
  {
    "date": "2025-12-09 09:00:00",
    "open": 168598.31,
    "low": 161858.11,
    "high": 173105.65,
    "close": 165416.5,
    "volume": 56585876
  },
  {
    "date": "2025-12-09 10:00:00",
    "open": 165416.5,
    "low": 165065.97,
    "high": 167915,
    "close": 166566.46,
    "volume": 52394130
  },
  {
    "date": "2025-12-09 11:00:00",
    "open": 166566.46,
    "low": 163085.32,
    "high": 169140.23,
    "close": 168722.96,
    "volume": 44831362
  },
  {
    "date": "2025-12-09 12:00:00",
    "open": 168722.96,
    "low": 165744.23,
    "high": 169027.72,
    "close": 167275.45,
    "volume": 61474724
  },
  {
    "date": "2025-12-09 13:00:00",
    "open": 167275.45,
    "low": 156720.69,
    "high": 192004.06,
    "close": 175910.39,
    "volume": 111951871
  },
  {
    "date": "2025-12-09 14:00:00",
    "open": 175910.39,
    "low": 169809.49,
    "high": 182167.49,
    "close": 172831.12,
    "volume": 56920212
  },
  {
    "date": "2025-12-09 15:00:00",
    "open": 172831.12,
    "low": 167405.38,
    "high": 173283.01,
    "close": 169184.19,
    "volume": 52401069
  },
  {
    "date": "2025-12-09 16:00:00",
    "open": 169184.19,
    "low": 164253.07,
    "high": 169698.62,
    "close": 165555.35,
    "volume": 52207312
  },
  {
    "date": "2025-12-09 17:00:00",
    "open": 165555.35,
    "low": 161718.76,
    "high": 173428.96,
    "close": 168393.3,
    "volume": 44636450
  },
  {
    "date": "2025-12-09 18:00:00",
    "open": 168393.3,
    "low": 166189.24,
    "high": 172113.55,
    "close": 170103.27,
    "volume": 46576220
  },
  {
    "date": "2025-12-09 19:00:00",
    "open": 170103.27,
    "low": 169876.56,
    "high": 170348.03,
    "close": 170167.14,
    "volume": 46222491
  },
  {
    "date": "2025-12-09 20:00:00",
    "open": 170167.14,
    "low": 165241.35,
    "high": 179356.2,
    "close": 173698.09,
    "volume": 56339334
  },
  {
    "date": "2025-12-09 21:00:00",
    "open": 173698.09,
    "low": 171815.95,
    "high": 174491.98,
    "close": 172767.62,
    "volume": 42847338
  },
  {
    "date": "2025-12-09 22:00:00",
    "open": 172767.62,
    "low": 172460,
    "high": 176076.55,
    "close": 174876.59,
    "volume": 57106165
  },
  {
    "date": "2025-12-09 23:00:00",
    "open": 174876.59,
    "low": 173837.68,
    "high": 176491.06,
    "close": 174142.97,
    "volume": 41064819
  },
  {
    "date": "2025-12-10 00:00:00",
    "open": 174142.97,
    "low": 139360.03,
    "high": 204975.68,
    "close": 155118.27,
    "volume": 169967918
  },
  {
    "date": "2025-12-10 01:00:00",
    "open": 155118.27,
    "low": 154724.11,
    "high": 156168.06,
    "close": 155456.11,
    "volume": 51043760
  },
  {
    "date": "2025-12-10 02:00:00",
    "open": 155456.11,
    "low": 140162.71,
    "high": 163054.11,
    "close": 147645.99,
    "volume": 164684516
  },
  {
    "date": "2025-12-10 03:00:00",
    "open": 147645.99,
    "low": 143456.37,
    "high": 149240.04,
    "close": 146253.65,
    "volume": 47347108
  },
  {
    "date": "2025-12-10 04:00:00",
    "open": 146253.65,
    "low": 144051.56,
    "high": 148943.78,
    "close": 147657.02,
    "volume": 150719823
  },
  {
    "date": "2025-12-10 05:00:00",
    "open": 147657.02,
    "low": 146495.06,
    "high": 149275.27,
    "close": 148201.88,
    "volume": 46916399
  },
  {
    "date": "2025-12-10 06:00:00",
    "open": 148201.88,
    "low": 145626.81,
    "high": 150773.87,
    "close": 149483.03,
    "volume": 46196301
  },
  {
    "date": "2025-12-10 07:00:00",
    "open": 149483.03,
    "low": 148241.42,
    "high": 151335.79,
    "close": 148572.4,
    "volume": 54096184
  },
  {
    "date": "2025-12-10 08:00:00",
    "open": 148572.4,
    "low": 146599.75,
    "high": 150921.28,
    "close": 149579.12,
    "volume": 63773770
  },
  {
    "date": "2025-12-10 09:00:00",
    "open": 149579.12,
    "low": 147876.38,
    "high": 153499.9,
    "close": 150852.26,
    "volume": 58931471
  },
  {
    "date": "2025-12-10 10:00:00",
    "open": 150852.26,
    "low": 150126.96,
    "high": 151437.46,
    "close": 150571.31,
    "volume": 51319286
  },
  {
    "date": "2025-12-10 11:00:00",
    "open": 150571.31,
    "low": 150287.16,
    "high": 150869.31,
    "close": 150641.11,
    "volume": 54410239
  },
  {
    "date": "2025-12-10 12:00:00",
    "open": 150641.11,
    "low": 150483.7,
    "high": 151806.81,
    "close": 151550.93,
    "volume": 54176874
  },
  {
    "date": "2025-12-10 13:00:00",
    "open": 151550.93,
    "low": 132940.38,
    "high": 152680.38,
    "close": 145054.59,
    "volume": 129875560
  },
  {
    "date": "2025-12-10 14:00:00",
    "open": 145054.59,
    "low": 144781.73,
    "high": 145253.07,
    "close": 144986.49,
    "volume": 57799740
  },
  {
    "date": "2025-12-10 15:00:00",
    "open": 144986.49,
    "low": 142542.59,
    "high": 147001.95,
    "close": 143032.97,
    "volume": 46158442
  },
  {
    "date": "2025-12-10 16:00:00",
    "open": 143032.97,
    "low": 137484.03,
    "high": 147438.04,
    "close": 140569.73,
    "volume": 52010414
  },
  {
    "date": "2025-12-10 17:00:00",
    "open": 140569.73,
    "low": 137932.44,
    "high": 143077.51,
    "close": 139313.23,
    "volume": 56691143
  },
  {
    "date": "2025-12-10 18:00:00",
    "open": 139313.23,
    "low": 137579.72,
    "high": 145015.13,
    "close": 141465.6,
    "volume": 55487588
  },
  {
    "date": "2025-12-10 19:00:00",
    "open": 141465.6,
    "low": 141278.96,
    "high": 144327.1,
    "close": 143109.74,
    "volume": 48039674
  },
  {
    "date": "2025-12-10 20:00:00",
    "open": 143109.74,
    "low": 142252.69,
    "high": 145053.3,
    "close": 144451.06,
    "volume": 57205280
  },
  {
    "date": "2025-12-10 21:00:00",
    "open": 144451.06,
    "low": 143924.22,
    "high": 144621.69,
    "close": 144271.24,
    "volume": 61096743
  },
  {
    "date": "2025-12-10 22:00:00",
    "open": 144271.24,
    "low": 122107.02,
    "high": 162989.42,
    "close": 160495.6,
    "volume": 166663574
  },
  {
    "date": "2025-12-10 23:00:00",
    "open": 160495.6,
    "low": 158353.25,
    "high": 162042.15,
    "close": 158599.83,
    "volume": 50170228
  },
  {
    "date": "2025-12-11 00:00:00",
    "open": 158599.83,
    "low": 157040.42,
    "high": 159459.99,
    "close": 158089.78,
    "volume": 48008672
  },
  {
    "date": "2025-12-11 01:00:00",
    "open": 158089.78,
    "low": 154631.56,
    "high": 161464.75,
    "close": 156025.97,
    "volume": 51968002
  },
  {
    "date": "2025-12-11 02:00:00",
    "open": 156025.97,
    "low": 155059.92,
    "high": 156255.2,
    "close": 155579.74,
    "volume": 48133692
  },
  {
    "date": "2025-12-11 03:00:00",
    "open": 155579.74,
    "low": 147679.44,
    "high": 167403.7,
    "close": 163258.53,
    "volume": 123123767
  },
  {
    "date": "2025-12-11 04:00:00",
    "open": 163258.53,
    "low": 162408.81,
    "high": 164818.91,
    "close": 164524.36,
    "volume": 41651068
  },
  {
    "date": "2025-12-11 05:00:00",
    "open": 164524.36,
    "low": 163844.6,
    "high": 168351.4,
    "close": 166359.39,
    "volume": 50434163
  },
  {
    "date": "2025-12-11 06:00:00",
    "open": 166359.39,
    "low": 156660.71,
    "high": 168499,
    "close": 163039.76,
    "volume": 54335773
  },
  {
    "date": "2025-12-11 07:00:00",
    "open": 163039.76,
    "low": 156104.87,
    "high": 166326.53,
    "close": 160754.73,
    "volume": 53748318
  },
  {
    "date": "2025-12-11 08:00:00",
    "open": 160754.73,
    "low": 155970.54,
    "high": 163645.56,
    "close": 158861.85,
    "volume": 46855909
  },
  {
    "date": "2025-12-11 09:00:00",
    "open": 158861.85,
    "low": 158214.49,
    "high": 159066.74,
    "close": 158667.13,
    "volume": 57529551
  },
  {
    "date": "2025-12-11 10:00:00",
    "open": 158667.13,
    "low": 151605.34,
    "high": 161917.4,
    "close": 156293.58,
    "volume": 50130844
  },
  {
    "date": "2025-12-11 11:00:00",
    "open": 156293.58,
    "low": 153176.39,
    "high": 160295.18,
    "close": 157939.6,
    "volume": 55715202
  },
  {
    "date": "2025-12-11 12:00:00",
    "open": 157939.6,
    "low": 155576.36,
    "high": 164391.06,
    "close": 162667.16,
    "volume": 172983829
  },
  {
    "date": "2025-12-11 13:00:00",
    "open": 162667.16,
    "low": 158417.21,
    "high": 164243.47,
    "close": 160306.84,
    "volume": 56761287
  },
  {
    "date": "2025-12-11 14:00:00",
    "open": 160306.84,
    "low": 160102.65,
    "high": 160500.76,
    "close": 160285.84,
    "volume": 51588181
  },
  {
    "date": "2025-12-11 15:00:00",
    "open": 160285.84,
    "low": 158629.08,
    "high": 162643.58,
    "close": 161406.66,
    "volume": 52944321
  },
  {
    "date": "2025-12-11 16:00:00",
    "open": 161406.66,
    "low": 160324.97,
    "high": 168444.22,
    "close": 164360.39,
    "volume": 63717634
  },
  {
    "date": "2025-12-11 17:00:00",
    "open": 164360.39,
    "low": 163827.58,
    "high": 170945.02,
    "close": 167322.54,
    "volume": 60304726
  },
  {
    "date": "2025-12-11 18:00:00",
    "open": 167322.54,
    "low": 165769.96,
    "high": 167595.34,
    "close": 166193.33,
    "volume": 49745698
  },
  {
    "date": "2025-12-11 19:00:00",
    "open": 166193.33,
    "low": 165593.49,
    "high": 168323.36,
    "close": 167341.74,
    "volume": 49129626
  },
  {
    "date": "2025-12-11 20:00:00",
    "open": 167341.74,
    "low": 147531.97,
    "high": 184426.51,
    "close": 177284.4,
    "volume": 153546200
  },
  {
    "date": "2025-12-11 21:00:00",
    "open": 177284.4,
    "low": 174881.01,
    "high": 179143.42,
    "close": 175650.4,
    "volume": 63512585
  },
  {
    "date": "2025-12-11 22:00:00",
    "open": 175650.4,
    "low": 175468.35,
    "high": 176120.12,
    "close": 175761.41,
    "volume": 49062843
  },
  {
    "date": "2025-12-11 23:00:00",
    "open": 175761.41,
    "low": 175349.33,
    "high": 176669.02,
    "close": 176268.09,
    "volume": 45292947
  },
  {
    "date": "2025-12-12 00:00:00",
    "open": 176268.09,
    "low": 164564.71,
    "high": 181708.76,
    "close": 172419.88,
    "volume": 88927367
  },
  {
    "date": "2025-12-12 01:00:00",
    "open": 172419.88,
    "low": 171414.78,
    "high": 173851.99,
    "close": 173315.5,
    "volume": 58326697
  },
  {
    "date": "2025-12-12 02:00:00",
    "open": 173315.5,
    "low": 169186.78,
    "high": 173800.11,
    "close": 171083.96,
    "volume": 57927995
  },
  {
    "date": "2025-12-12 03:00:00",
    "open": 171083.96,
    "low": 170527.94,
    "high": 171403.66,
    "close": 170936.78,
    "volume": 46800750
  },
  {
    "date": "2025-12-12 04:00:00",
    "open": 170936.78,
    "low": 169289.41,
    "high": 172494.33,
    "close": 171862.66,
    "volume": 44178032
  },
  {
    "date": "2025-12-12 05:00:00",
    "open": 171862.66,
    "low": 142407.38,
    "high": 202753.01,
    "close": 152599.92,
    "volume": 175814161
  },
  {
    "date": "2025-12-12 06:00:00",
    "open": 152599.92,
    "low": 149040.72,
    "high": 155235.83,
    "close": 149861.09,
    "volume": 43805904
  },
  {
    "date": "2025-12-12 07:00:00",
    "open": 149861.09,
    "low": 146011.71,
    "high": 151095.72,
    "close": 147854.1,
    "volume": 57890789
  },
  {
    "date": "2025-12-12 08:00:00",
    "open": 147854.1,
    "low": 144665.23,
    "high": 149248.63,
    "close": 146282.18,
    "volume": 43507311
  },
  {
    "date": "2025-12-12 09:00:00",
    "open": 146282.18,
    "low": 146065.79,
    "high": 146458.2,
    "close": 146257.44,
    "volume": 40618829
  },
  {
    "date": "2025-12-12 10:00:00",
    "open": 146257.44,
    "low": 145052.19,
    "high": 146976.19,
    "close": 145325.98,
    "volume": 60691167
  },
  {
    "date": "2025-12-12 11:00:00",
    "open": 145325.98,
    "low": 144399.42,
    "high": 145683.84,
    "close": 145061.44,
    "volume": 50720485
  },
  {
    "date": "2025-12-12 12:00:00",
    "open": 145061.44,
    "low": 143698.01,
    "high": 146846.04,
    "close": 145737.45,
    "volume": 41862980
  },
  {
    "date": "2025-12-12 13:00:00",
    "open": 145737.45,
    "low": 140977.32,
    "high": 148919.64,
    "close": 148324.34,
    "volume": 53380612
  },
  {
    "date": "2025-12-12 14:00:00",
    "open": 148324.34,
    "low": 139639.03,
    "high": 148855.21,
    "close": 141304.92,
    "volume": 90538955
  },
  {
    "date": "2025-12-12 15:00:00",
    "open": 141304.92,
    "low": 136148.53,
    "high": 156236.63,
    "close": 146500.35,
    "volume": 100894448
  },
  {
    "date": "2025-12-12 16:00:00",
    "open": 146500.35,
    "low": 144855.32,
    "high": 147888.74,
    "close": 145859.09,
    "volume": 54359995
  },
  {
    "date": "2025-12-12 17:00:00",
    "open": 145859.09,
    "low": 140967.21,
    "high": 146726.38,
    "close": 143842.48,
    "volume": 60235232
  },
  {
    "date": "2025-12-12 18:00:00",
    "open": 143842.48,
    "low": 141517.49,
    "high": 146559.64,
    "close": 145688.01,
    "volume": 45089201
  },
  {
    "date": "2025-12-12 19:00:00",
    "open": 145688.01,
    "low": 145203.07,
    "high": 145985.73,
    "close": 145525.96,
    "volume": 63159084
  },
  {
    "date": "2025-12-12 20:00:00",
    "open": 145525.96,
    "low": 145037.98,
    "high": 145954.24,
    "close": 145799.23,
    "volume": 56987786
  },
  {
    "date": "2025-12-12 21:00:00",
    "open": 145799.23,
    "low": 141050.72,
    "high": 152230.64,
    "close": 151410.97,
    "volume": 122086272
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 151410.97,
    "low": 147718.77,
    "high": 157204.72,
    "close": 154145.19,
    "volume": 44453641
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 154145.19,
    "low": 153345.29,
    "high": 155876.43,
    "close": 155455.32,
    "volume": 53557952
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 155455.32,
    "low": 151583.12,
    "high": 156374.91,
    "close": 154022.43,
    "volume": 49110435
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 154022.43,
    "low": 152371.69,
    "high": 155712.61,
    "close": 154780.82,
    "volume": 56500350
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 154780.82,
    "low": 151985.45,
    "high": 157298.63,
    "close": 156361.86,
    "volume": 64626959
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 156361.86,
    "low": 121521.66,
    "high": 183976.16,
    "close": 174901.79,
    "volume": 166028333
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 174901.79,
    "low": 170783.44,
    "high": 177807.85,
    "close": 173533.09,
    "volume": 53814007
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 173533.09,
    "low": 172428.68,
    "high": 173960.19,
    "close": 173207.57,
    "volume": 46938665
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 173207.57,
    "low": 170468.66,
    "high": 173429.42,
    "close": 171743.36,
    "volume": 64011244
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 171743.36,
    "low": 171544.16,
    "high": 172008.06,
    "close": 171811.41,
    "volume": 60573174
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 171811.41,
    "low": 170578.65,
    "high": 173166.75,
    "close": 171214.7,
    "volume": 53109946
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 171214.7,
    "low": 170049.78,
    "high": 173203.12,
    "close": 172685.12,
    "volume": 49179211
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 172685.12,
    "low": 171613.12,
    "high": 174435.53,
    "close": 173227,
    "volume": 49476582
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 173227,
    "low": 164859.03,
    "high": 179194.75,
    "close": 170140.84,
    "volume": 124748718
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 170140.84,
    "low": 167536.95,
    "high": 172621.13,
    "close": 168281.62,
    "volume": 47772735
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 168281.62,
    "low": 167918.85,
    "high": 168520.53,
    "close": 168207.1,
    "volume": 60224659
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 168207.1,
    "low": 165156.32,
    "high": 171906.61,
    "close": 169867.15,
    "volume": 47263812
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 169867.15,
    "low": 168446.38,
    "high": 174792.77,
    "close": 171645.85,
    "volume": 62488026
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 171645.85,
    "low": 169310.04,
    "high": 172850.76,
    "close": 170813.86,
    "volume": 52256444
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 170813.86,
    "low": 150773.26,
    "high": 176273.06,
    "close": 159965.26,
    "volume": 118321829
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 159965.26,
    "low": 157580.08,
    "high": 161729.13,
    "close": 158389.35,
    "volume": 52125003
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 158389.35,
    "low": 153177.03,
    "high": 160905.94,
    "close": 156585.15,
    "volume": 43304223
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 156585.15,
    "low": 156347.37,
    "high": 157136.04,
    "close": 156716.81,
    "volume": 63690242
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 156716.81,
    "low": 152621.98,
    "high": 161891.93,
    "close": 158776.28,
    "volume": 44895802
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 158776.28,
    "low": 157745.73,
    "high": 159941.5,
    "close": 159219.63,
    "volume": 47845882
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 159219.63,
    "low": 154898.3,
    "high": 163270.61,
    "close": 161614.8,
    "volume": 59250200
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 161614.8,
    "low": 161246.09,
    "high": 162808.81,
    "close": 162142.96,
    "volume": 43777082
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 162142.96,
    "low": 156031.13,
    "high": 162379.96,
    "close": 158843.76,
    "volume": 55461779
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 158843.76,
    "low": 151795.09,
    "high": 159991.43,
    "close": 156314.1,
    "volume": 46900219
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 156314.1,
    "low": 149541.86,
    "high": 159786.32,
    "close": 153084.21,
    "volume": 62769710
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 153084.21,
    "low": 152479.28,
    "high": 157604.24,
    "close": 155125.84,
    "volume": 57091692
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 155125.84,
    "low": 154520.85,
    "high": 155381.18,
    "close": 154955.85,
    "volume": 55698958
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 154955.85,
    "low": 153590.81,
    "high": 169208.78,
    "close": 160601.19,
    "volume": 109158395
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 160601.19,
    "low": 157044.01,
    "high": 161213.88,
    "close": 159072.05,
    "volume": 60868419
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 159072.05,
    "low": 155988.43,
    "high": 160996.45,
    "close": 157678.8,
    "volume": 43319743
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 157678.8,
    "low": 155368.09,
    "high": 158535.42,
    "close": 156922.64,
    "volume": 53380999
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 156922.64,
    "low": 155516.01,
    "high": 160530.63,
    "close": 159288.85,
    "volume": 42492152
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 159288.85,
    "low": 157300.89,
    "high": 160963.42,
    "close": 158503.68,
    "volume": 58773838
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 158503.68,
    "low": 153683.21,
    "high": 161981.61,
    "close": 161185.42,
    "volume": 49813546
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 161185.42,
    "low": 147618.53,
    "high": 190080.65,
    "close": 172127.57,
    "volume": 112194263
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 172127.57,
    "low": 168282.03,
    "high": 175211.63,
    "close": 174074.43,
    "volume": 64913559
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 174074.43,
    "low": 172015.85,
    "high": 178067.59,
    "close": 177043.37,
    "volume": 53135519
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 177043.37,
    "low": 174005.49,
    "high": 177496.1,
    "close": 175800.94,
    "volume": 54608130
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 175800.94,
    "low": 166280.64,
    "high": 176657.72,
    "close": 172019.29,
    "volume": 44689636
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 172019.29,
    "low": 171158.84,
    "high": 174241.15,
    "close": 172866.21,
    "volume": 56775708
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 172866.21,
    "low": 172615.12,
    "high": 173181.16,
    "close": 172915.41,
    "volume": 53354274
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 172915.41,
    "low": 169774.88,
    "high": 178529.68,
    "close": 175223.59,
    "volume": 50261659
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 175223.59,
    "low": 164577.77,
    "high": 192500.98,
    "close": 165419.06,
    "volume": 93843426
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 165419.06,
    "low": 164392.73,
    "high": 167985.14,
    "close": 166951.06,
    "volume": 42191028
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 166951.06,
    "low": 162114.85,
    "high": 169257.54,
    "close": 163814.13,
    "volume": 60309963
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 163814.13,
    "low": 161045.23,
    "high": 165584.33,
    "close": 162506.99,
    "volume": 45293050
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 162506.99,
    "low": 160116.08,
    "high": 168042.14,
    "close": 164906.23,
    "volume": 64968857
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 164906.23,
    "low": 143601.88,
    "high": 167027.09,
    "close": 156610.38,
    "volume": 105981343
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 156610.38,
    "low": 153583.9,
    "high": 159011.4,
    "close": 154082.05,
    "volume": 51409357
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 154082.05,
    "low": 152853.84,
    "high": 159998.82,
    "close": 156783.08,
    "volume": 40714617
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 156783.08,
    "low": 149272.69,
    "high": 158728.61,
    "close": 154165.03,
    "volume": 64924211
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 154165.03,
    "low": 149789.75,
    "high": 155276.54,
    "close": 152519.92,
    "volume": 42370002
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 152519.92,
    "low": 152080.31,
    "high": 155552.35,
    "close": 155157.01,
    "volume": 47764394
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 155157.01,
    "low": 151293.88,
    "high": 163249.63,
    "close": 158056.26,
    "volume": 59101804
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 158056.26,
    "low": 155506.97,
    "high": 162531.97,
    "close": 160013.78,
    "volume": 48837933
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 160013.78,
    "low": 159085.04,
    "high": 162188.36,
    "close": 160712.05,
    "volume": 41876966
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 160712.05,
    "low": 159704.81,
    "high": 161861.46,
    "close": 161181.37,
    "volume": 51236406
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 161181.37,
    "low": 160905.96,
    "high": 162968.71,
    "close": 161764.49,
    "volume": 46921982
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 161764.49,
    "low": 155931.77,
    "high": 164085.36,
    "close": 158879.91,
    "volume": 57286681
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 158879.91,
    "low": 153456.57,
    "high": 166566.15,
    "close": 162148.91,
    "volume": 44728346
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 162148.91,
    "low": 136432.68,
    "high": 196039.67,
    "close": 144413.92,
    "volume": 182541900
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 144413.92,
    "low": 142017.42,
    "high": 147017.13,
    "close": 142425.7,
    "volume": 40601177
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 142425.7,
    "low": 140925.35,
    "high": 145596.43,
    "close": 143755.59,
    "volume": 43389356
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 143755.59,
    "low": 141070.04,
    "high": 147888.75,
    "close": 145108.57,
    "volume": 51453454
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 145108.57,
    "low": 142158.55,
    "high": 145271.15,
    "close": 144128.28,
    "volume": 54930488
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 144128.28,
    "low": 134880.55,
    "high": 151294.61,
    "close": 140472.55,
    "volume": 93708008
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 140472.55,
    "low": 140208.24,
    "high": 141133.42,
    "close": 140675.56,
    "volume": 40830047
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 140675.56,
    "low": 139461.9,
    "high": 141196.48,
    "close": 140207.28,
    "volume": 54815740
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 140207.28,
    "low": 137709.4,
    "high": 142486.38,
    "close": 141524.88,
    "volume": 55463722
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 141524.88,
    "low": 119876.7,
    "high": 182667.27,
    "close": 161454.93,
    "volume": 183406468
  }
]